<template>
  <footer class="mega-footer" aria-label="메가 사이트 이용 안내">
    <div class="mega-footer-inner">
      <div class="mega-footer-payments" aria-label="결제 브랜드">
        <img src="@/assets/img/visa.png" alt="Visa" width="87" height="68" loading="lazy" />
        <img src="@/assets/img/master.png" alt="Mastercard" width="87" height="68" loading="lazy" />
        <img src="@/assets/img/paypal.png" alt="PayPal" width="87" height="68" loading="lazy" />
        <img src="@/assets/img/amex.png" alt="American Express" width="87" height="68" loading="lazy" />
      </div>
      <div class="mega-footer-providers" aria-label="게임 제공사">
        <img src="@/assets/img/evolution_on.svg" alt="Evolution" loading="lazy" />
        <img src="@/assets/img/pragmaticplay_on.svg" alt="Pragmatic Play" loading="lazy" />
        <img src="@/assets/img/footer_microgaming.svg" alt="Microgaming" loading="lazy" />
        <img src="@/assets/img/footer_netent.svg" alt="NetEnt" loading="lazy" />
        <img src="@/assets/img/footer_redtiger.svg" alt="Red Tiger" loading="lazy" />
        <img src="@/assets/img/footer_CQ9.svg" alt="CQ9" loading="lazy" />
      </div>

      <div class="mega-footer-notice">
        <img src="@/assets/img/mega-login-logo.png" alt="메가 CASINO" width="86" height="64" loading="lazy" />
        <div>
          <strong>메가 이용 안내</strong>
          <p>서비스 이용 전 공지사항과 이용 규정을 확인해주세요.<br />이용 중 도움이 필요하시면 고객센터로 문의해주세요.</p>
        </div>
      </div>
      <p class="mega-footer-copyright">© 메가. All rights reserved.</p>
    </div>
  </footer>
</template>

<style scoped>
.mega-footer { width: 100%; background: #0d1512; border-top: 1px solid #29302d; color: #a7aeaa; }
.mega-footer-inner { max-width: 1000px; margin: 0 auto; padding: 22px 28px 28px; text-align: center; box-sizing: border-box; }
.mega-footer-payments, .mega-footer-providers { display: flex; align-items: center; justify-content: center; flex-wrap: wrap; gap: 12px 24px; }
.mega-footer-payments img { width: 78px; height: 44px; object-fit: contain; filter: grayscale(1) brightness(0) invert(1); opacity: .52; }
.mega-footer-providers { margin-top: 10px; gap: 14px 25px; }
.mega-footer-providers img { width: 84px; height: 27px; object-fit: contain; filter: grayscale(1) brightness(0) invert(1); opacity: .58; }
.mega-footer-notice { display: flex; align-items: center; gap: 20px; margin-top: 24px; padding: 8px 18px; border: 1px solid #46514a; border-radius: 7px; text-align: left; }
.mega-footer-notice > img { flex: 0 0 86px; width: 86px; height: 64px; object-fit: contain; filter: grayscale(1); opacity: .7; }
.mega-footer-notice > div { border-left: 1px solid #46514a; padding-left: 20px; }
.mega-footer-notice strong { display: block; margin-bottom: 5px; font-size: 12px; font-weight: 600; color: #c5cbc7; }
.mega-footer-notice p { margin: 0; font-size: 10px; line-height: 1.7; word-break: keep-all; }
.mega-footer-copyright { margin: 28px 0 0; font-size: 10px; color: #939d96; }
@media (max-width: 600px) {
  .mega-footer-inner { padding: 20px 18px 26px; }
  .mega-footer-payments { gap: 10px; }
  .mega-footer-payments img { width: 60px; height: 42px; }
  .mega-footer-providers { max-width: 330px; margin: 12px auto 0; gap: 16px 18px; }
  .mega-footer-providers img { width: 80px; height: 26px; }
  .mega-footer-notice { gap: 12px; padding: 12px 10px; }
  .mega-footer-notice > img { flex-basis: 60px; width: 60px; height: 54px; }
  .mega-footer-notice > div { padding-left: 12px; }
  .mega-footer-notice strong { font-size: 11px; }
  .mega-footer-notice p { font-size: 10px; }
}
</style>
